export default __webpack_public_path__ + "static/media/whitehat_medium.c7f4f6a9.png";